import React from 'react';
import PropTypes from 'prop-types';
import useHeaderSearch from './hooks/useHeaderSearch';
import HeaderSearchSuggestions from './HeaderSearchSuggestions';

function HeaderSearch(props) {
  const { labels, ...config } = useHeaderSearch(props);

  return (
    <div className="header-search__form-suggestions-wrapper">
      <form
        className="header-search__form"
        role="combobox"
        aria-expanded={config.showResults ? 'true' : 'false'}
        aria-owns="header-search-suggestions"
        aria-haspopup="listbox"
        action={props.searchUrl}
        onSubmit={e => config.handleSearchSubmit(e)}
        onReset={e => config.handleFormReset(e)}
        noValidate
      >
        {!config.term && <span aria-hidden="true" className="header-search__label">{labels.searchLabel}</span>}
        <input
          className="header-search__input"
          type="search"
          id="header-search"
          name={props.searchUrlQuery}
          autoComplete="off"
          aria-autocomplete="list"
          aria-controls="header-search-suggestions"
          aria-label={labels.searchLabel}
          onChange={config.onChange}
          onFocus={config.onFocus}
          onBlur={config.onBlur}
          onKeyDown={config.onKeyDown}
          onKeyUp={config.onKeyUp}
          placeholder={labels.placeholder}
          value={config.term}
          required
        />
        {!!config.term && <button onMouseDown={config.handleFormReset} type="reset" className="link link--small header-search__reset">{labels.clear}</button>}
        {!config.term && config.focused && <button onMouseDown={config.handleClose} type="reset" className="link link--small header-search__reset">{labels.close}</button>}
        <button aria-label={labels.searchSubmit} className="header-search__submit" type="submit" onMouseDown={config.handleSearchSubmit}>
          <svg viewBox="0 0 307 320"><use xlinkHref="#search" /></svg>
        </button>
      </form>
      <HeaderSearchSuggestions onViewAllClick={config.handleViewAll} focusedIndex={config.currentResultIndex} isVisible={config.showResults} labels={labels} items={config.suggestions} />
    </div>
  )
}

HeaderSearch.defaultProps = {

};

HeaderSearch.propTypes = {

};

export default HeaderSearch;
